// AUTO-GENERATED from packages/ws-protocol/kinds.toml
// Run `pnpm gen:ws-protocol` to regenerate. Do not edit by hand.

export const PROTOCOL_VERSION = 2;

// Flag bits
export const FLAG_HAS_SCOPE_ID = 0x01;
export const FLAG_HAS_CORR_ID = 0x02;
export const FLAG_HAS_JSON = 0x04;
export const FLAG_HAS_BINARY = 0x08;

// Message kinds
export const KIND_AUTH                = 0x01;  // C→S: auth with token + client identity
export const KIND_AUTH_OK             = 0x02;  // S→C: auth accepted
export const KIND_AUTH_ERROR          = 0x03;  // S→C: auth rejected
export const KIND_SUBSCRIBE           = 0x04;  // C→S: join entity room
export const KIND_SUBSCRIBE_OK        = 0x05;  // S→C: subscribe confirmed
export const KIND_UNSUBSCRIBE         = 0x06;  // C→S: leave entity room
export const KIND_UNSUBSCRIBE_OK      = 0x07;  // S→C: unsubscribe confirmed
export const KIND_ERROR               = 0x08;  // S→C: generic error (spontaneous or correlated)
export const KIND_WORKSPACE_MEMBERSHIP_CHANGED= 0x10;  // S→C: membership or role/permission changed; client reacts (kick / refresh)
export const KIND_OPS                 = 0x20;  // C→S: ops batch (JSON, optional binary via binaryTarget)
export const KIND_OP_RESULT           = 0x21;  // S→C: per-op acks
export const KIND_SNAPSHOT_OP         = 0x22;  // C→S: snapshot op (create/update/delete/restore — separate rail because snapshots aren't entities-table rows)
export const KIND_SYNC_REQUEST        = 0x30;  // C→S: bootstrap or catch-up
export const KIND_SYNC_RESPONSE       = 0x31;  // S→C: event batch + next cursor
export const KIND_SYNC_EVENT          = 0x32;  // S→C: single event broadcast
export const KIND_YJS_SYNC_STEP1      = 0x40;  // bidi: state vector exchange start
export const KIND_YJS_SYNC_STEP2      = 0x41;  // bidi: state delta response
export const KIND_YJS_UPDATE          = 0x42;  // bidi: incremental CRDT update
export const KIND_YJS_AWARENESS       = 0x43;  // bidi: presence/cursor state
export const KIND_AGENT_RUN           = 0x70;  // C→S: start an agent run
export const KIND_AGENT_EVENT         = 0x71;  // S→C: agent progress event (thought, tool_start, text_chunk, etc.)
export const KIND_AGENT_APPROVE       = 0x72;  // C→S: resolve an agent approval request
export const KIND_AGENT_CANCEL        = 0x73;  // C→S: cancel an in-flight agent run
export const KIND_AGENT_DONE          = 0x74;  // S→C: terminal agent run frame
export const KIND_AGENT_WORKFLOWS     = 0x75;  // S→C: workflow list push on WS connect (JSON body)
export const KIND_AGENT_TOOL          = 0x76;  // C→S: start a conversation-less tool run (ai-composer / editor edits)
export const KIND_AGENT_END           = 0x77;  // C→S: explicit conversation close

// Debug helper: map kind byte to human-readable name.
export const KIND_NAMES: Record<number, string> = {
  0x01: 'AUTH',
  0x02: 'AUTH_OK',
  0x03: 'AUTH_ERROR',
  0x04: 'SUBSCRIBE',
  0x05: 'SUBSCRIBE_OK',
  0x06: 'UNSUBSCRIBE',
  0x07: 'UNSUBSCRIBE_OK',
  0x08: 'ERROR',
  0x10: 'WORKSPACE_MEMBERSHIP_CHANGED',
  0x20: 'OPS',
  0x21: 'OP_RESULT',
  0x22: 'SNAPSHOT_OP',
  0x30: 'SYNC_REQUEST',
  0x31: 'SYNC_RESPONSE',
  0x32: 'SYNC_EVENT',
  0x40: 'YJS_SYNC_STEP1',
  0x41: 'YJS_SYNC_STEP2',
  0x42: 'YJS_UPDATE',
  0x43: 'YJS_AWARENESS',
  0x70: 'AGENT_RUN',
  0x71: 'AGENT_EVENT',
  0x72: 'AGENT_APPROVE',
  0x73: 'AGENT_CANCEL',
  0x74: 'AGENT_DONE',
  0x75: 'AGENT_WORKFLOWS',
  0x76: 'AGENT_TOOL',
  0x77: 'AGENT_END',
};

export function kindName(kind: number): string {
  return KIND_NAMES[kind] ?? `Unknown(0x${kind.toString(16).padStart(2, '0')})`;
}
